import * as yup from 'yup';

export const maintenanceOrderSchema = yup.object({
  locationType: yup
    .string()
    .oneOf(['room', 'common_area'])
    .default('room'),
  roomId: yup.string().when('locationType', {
    is: 'room',
    then: (schema) => schema.required('La habitación es requerida'),
    otherwise: (schema) => schema.nullable()
  }),
  commonAreaId: yup.string().when('locationType', {
    is: 'common_area',
    then: (schema) => schema.required('El área común es requerida'),
    otherwise: (schema) => schema.nullable()
  }),
  title: yup.string().trim().required('El título es requerido'),
  description: yup.string().nullable(),
  type: yup
    .string()
    .oneOf(['OO', 'OS'])
    .required('El tipo (OO/OS) es requerido'),
  category: yup
    .string()
    .oneOf([
      'plumbing',
      'electrical',
      'carpentry',
      'ac',
      'appliances',
      'furniture',
      'painting',
      'general'
    ])
    .required(),
  priority: yup
    .string()
    .oneOf(['low', 'medium', 'high', 'urgent'])
    .required(),
  // blockFrom / blockTo solo son obligatorias para habitaciones; las áreas
  // comunes no bloquean reservas.
  blockFrom: yup.date().when('locationType', {
    is: 'room',
    then: (schema) => schema.required('Fecha desde es requerida'),
    otherwise: (schema) => schema.nullable()
  }),
  blockTo: yup.date().when('locationType', {
    is: 'room',
    then: (schema) =>
      schema
        .min(yup.ref('blockFrom'), 'Fecha hasta debe ser posterior a desde')
        .required('Fecha hasta es requerida'),
    otherwise: (schema) => schema.nullable()
  }),
  estimatedEndDate: yup.date().nullable(),
  assignedTo: yup.string().nullable(),
  autoReleaseToStatus: yup.string().oneOf(['dirty', 'clean']).default('dirty'),
  cost: yup.object({
    materials: yup.number().min(0).default(0),
    labor: yup.number().min(0).default(0),
    currency: yup.string().default('USD'),
    notes: yup.string().nullable()
  })
});
